{makeAction} = require 'utils/action_helpers.coffee'
{browserHistory} = require 'react-router'

module.exports =
  redirect: (location, timeout = 0, callback) -> makeAction (setState) ->
    setTimeout ->
      browserHistory.push location
      callback?()
    , timeout
